export function getEnv(){
    const host = window.location.host;
    const identifier = host.indexOf('local') > -1
        ? 'dev'
        : host.split('-')[0];
    let env;
    switch(identifier) {
        case 'dev' :
            env = 'development';
            break;
        default : 
            env = 'production';
            break;
    }
    return env;
}
